// extracted by mini-css-extract-plugin
module.exports = {"social":"Jj","fbIcon":"Kj","instaIcon":"Lj","twitIcon":"Mj","pinIcon":"Nj","ytIcon":"Oj"};